// 意大利
export default {
  Login: {
    Title: "Accedi al tuo account",
    describe: "Accedi o crea un account per iniziare.",
    Google: "Continua con Google",
    Apple: "Continua con Apple",
    or: "O",
    Emailplaceholder: "Indirizzo email",
    Passwordplaceholder: "Password",
    Login: "Accedi",
    forgot: "Hai dimenticato la password?",
    notAccount: "Non hai un account Fineshare?",
    Signup: "Registrati",
    InvalidEmail: "Formato email non valido.",
    InvalidPassword: "La password deve contenere almeno 6 caratteri.",
    loading: "Caricamento...",
    login: "Accedi",
    errorText: "Accesso fallito, verifica il tuo nome utente e la tua password",
  },
  signup: {
    Title: "Crea il tuo account",
    describe: "Crea il tuo account Fineshare in pochi secondi.",
    Google: "Registrati con Google",
    Apple: "Registrati con Apple",
    or: "O",
    Emailplaceholder: "Inserisci l'indirizzo email",
    Passwordplaceholder: "Inserisci una password di 6 cifre",
    Already: "Hai già un account?",
    Login: "Accedi",
    By: "Creando un account, accetto di aver letto e accettato la",
    Privacy: "Politica sulla privacy",
    Terms: "Termini di utilizzo.",
    and: "e",
    signupText: "Crea il tuo account",
    InvalidEmail: "Formato email non valido.",
    InvalidPassword: "La password deve contenere almeno 6 caratteri.",
    loading: "Caricamento...",
    passwordError: "L'indirizzo email è già stato registrato",
    again: "Stai facendo troppe richieste, riprova più tardi",
    Registration: "Registrazione fallita, verifica la tua email e password.",
    hasRegistered: "L'indirizzo email è già stato registrato",
  },
  Home: {
    Welcome: "Benvenuto nel Centro Account di Fineshare",
  },
};
